import { Component, Renderer2, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RelevantNewsarticleComponent } from '../relevant-newsarticle/relevant-newsarticle.component';

interface ArticlePost {
  id: number;
  title: string;
  image: string;
  slug?: string;
}

@Component({
  selector: 'app-goodfirms-pr',
  imports: [CommonModule, RelevantNewsarticleComponent],
  standalone: true,
  templateUrl: './goodfirms-pr.component.html',
  styleUrl: './goodfirms-pr.component.scss'
})
export class GoodfirmsPrComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }

  ngOnInit(): void {
    this.injectSchemaMarkup();
  }

  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const goodFirmsSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/goodfirms",
          "url": "https://www.kalpitatechnologies.com/kalpita-press-release/goodfirms",
          "name": "GoodFirms Features Kalpita Technologies — Executive Interview",
          "description": "GoodFirms features an executive interview with CEO Kube G, covering AI-enabled automation, 70% repeat client rate, and a 10-year vision for applied AI leadership.",
          "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": [
              ".softwaredev-heading",
              ".takeaways-section .takeaway-item p",
              ".section-title"
            ]
          },
          "significantLink": ["https://www.goodfirms.co/company/kalpita-technologies#interview"],
          "datePublished": "2025-05-01",
          "dateModified": "2025-05-01",
          "isPartOf": { "@type": "WebSite", "@id": "https://www.kalpitatechnologies.com/#website" }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/goodfirms#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com/" },
            { "@type": "ListItem", "position": 2, "name": "News", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/inthenews" },
            { "@type": "ListItem", "position": 3, "name": "GoodFirms Interview", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/goodfirms" }
          ]
        },
        {
          "@type": "TechArticle",
          "headline": "GoodFirms Features Kalpita Technologies: Executive Interview with CEO Kube G",
          "alternativeHeadline": "How Kalpita Delivers AI-Enabled Automation and 70% Repeat Client Retention",
          "articleBody": "In an executive interview featured on GoodFirms, Kube G, CEO of Kalpita Technologies, shares the story behind building an outcome-oriented tech firm...",
          "author": { "@type": "Organization", "name": "GoodFirms" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2025-05-01"
        },
        {
          "@type": "HowTo",
          "name": "How to Build a Client-Trusted Technology Firm Like Kalpita Technologies",
          "description": "Step-by-step guide to building a successful technology company with high repeat-client trust.",
          "step": [
            { "@type": "HowToStep", "name": "Build Core Expertise", "text": "Develop capabilities in AI, enterprise software, and Cloud/DevOps services." },
            { "@type": "HowToStep", "name": "Deliver Measurable Impact", "text": "Focus on outcome-driven engineering that results in 70%+ manual error reduction." },
            { "@type": "HowToStep", "name": "Foster Strong Culture", "text": "Establish core values based on innovation, agility, and empathy." },
            { "@type": "HowToStep", "name": "Relationship Management", "text": "Assign dedicated account managers and conduct regular strategy syncs." },
            { "@type": "HowToStep", "name": "Set Ambitious Goals", "text": "Define a 10-year roadmap for applied AI leadership and global expansion." }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What services does Kalpita Technologies offer?",
              "acceptedAnswer": { "@type": "Answer", "text": "Services include AI-enabled automation, custom enterprise software, UI/UX design, MVP development, and Cloud/DevOps services." }
            },
            {
              "@type": "Question",
              "name": "What industries does the company serve?",
              "acceptedAnswer": { "@type": "Answer", "text": "Kalpita primarily serves the InsurTech, FinTech, and Healthcare industries." }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.kalpitatechnologies.com/#localbusiness",
          "name": "Kalpita Technologies — Austin Office",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Suite #300, 3rd Floor, Building 2, 1250 South Capital of Texas Highway",
            "addressLocality": "Austin",
            "addressRegion": "TX",
            "postalCode": "78746",
            "addressCountry": "US"
          },
          "telephone": "+1-512-240-2484",
          "url": "https://www.kalpitatechnologies.com/"
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(goodFirmsSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  articles: ArticlePost[] = [
    {
      id: 1,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-one.webp'
    },
    {
      id: 2,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-two.webp'
    },
    {
      id: 3,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-three.webp'
    },
    {
      id: 4,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-four.webp'
    },
    {
      id: 5,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-five.webp'
    },
    {
      id: 6,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-six.webp'
    },
    {
      id: 7,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-seven.webp'
    },
    {
      id: 8,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-eight.webp'
    }
  ];
  onArticleClick(article: ArticlePost): void {
    console.log('Article clicked:', article);
    // Handle navigation to article detail page
  }

  trackByArticle(index: number, article: ArticlePost): number {
    return article.id;
  }
}
